import Resource from '@/api/resources/Resource'

class BatchPrintingDashboardServices extends Resource {
    async getTemplatesByLaboratory(labId) {
        const response = await this.axios.get(`/dashboard/laboratories/${labId}/batchPrintingTemplate`)
        return response.data
    }
    async createTemplate(labId, batchPrintingTemplateRequest, overwriteToBeUsedByDefault = false) {
        const params = {
            overwriteToBeUsedByDefault
        }
        const response = await this.axios.post(`/dashboard/laboratories/${labId}/batchPrintingTemplate`, batchPrintingTemplateRequest, { params })
        return response.data
    }
    async generateLabels(labId, batchPrintingTemplateRequest) {
        const response = await this.axios.put(`/dashboard/laboratories/${labId}/generateLabels`, batchPrintingTemplateRequest)
        return response.data
    }
    async updateTemplate(labId, batchPrintingTemplateId, batchPrintingTemplateRequest, overwriteToBeUsedByDefault = false) {
        const params = {
            overwriteToBeUsedByDefault
        }
        const response = await this.axios.put(`/dashboard/laboratories/${labId}/batchPrintingTemplate/${batchPrintingTemplateId}`, batchPrintingTemplateRequest, { params })
        return response.data
    }
    async generateLabelsForPrint(labId, batchPrintingTemplateRequest) {
        const response = await this.axios.put(`/dashboard/laboratories/${labId}/generateLabelsAndPdf`, batchPrintingTemplateRequest)
        return response.data
    }
    async generateSelectedLabelsForPrint(labId, selectedLabels, numEntitiesOfCaseStudies) {
        const params = {
            numEntitiesOfCaseStudies
        }
        const response = await this.axios.put(`/dashboard/laboratories/${labId}/generateSelectedLabelsThatWillBePrinted`, selectedLabels, { params })
        return response.data
    }
    async deleteTemplateBatch(labId, entityIdentifiers) {
        const response = await this.axios.delete(`/dashboard/laboratories/${labId}/printingTemplate/deleteBatch`, { data: { entityIdentifiers } })
        return response.data
    }
}

export const COREENTITY_PRINT_LABELS_VALUES = {
    CASE: 'CASE',
    SAMPLE: 'SAMPLE',
    PORTION: 'PORTION',
    SUBPORTION: 'SUBPORTION'
}

export const ENTITY_LABELS = {
    REGISTRY_LABEL: 'CASE_LABEL',
    SAMPLE_LABEL: 'SAMPLE_LABEL',
    CASSETTE_PARAFFIN_BLOCK_LABEL: 'CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL',
    SUBPORTION_SLIDE_LABEL: 'SUBPORTION_SLIDE_LABEL'
}

export default new BatchPrintingDashboardServices()
